import { render } from "./NavOverlay.vue?vue&type=template&id=221a1fe4"
import script from "./NavOverlay.vue?vue&type=script&lang=ts"
export * from "./NavOverlay.vue?vue&type=script&lang=ts"

import "./NavOverlay.vue?vue&type=style&index=0&id=221a1fe4&lang=scss"
script.render = render

export default script